import { Check, Input } from "@frui.ts/bootstrap";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import Button from "@edaz/edazkit/Button";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { preventDefault, registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { ButtonToolbar } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import ChangeEmailViewModel from "viewModels/callCenter/search/charges/changeEmailViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";

const ChangeEmailView: ViewComponent<ChangeEmailViewModel> = observer(({ vm }) => {
  return (
    <Modal show={true} onHide={vm.onClose} dialogClassName="modal-md" centered>
      <Modal.Header closeButton={true}>
        <Modal.Title>{vm.translate("name")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          <Form onSubmit={preventDefault(vm.onSubmit)}>
            <Form.Row>
              <FormGroup as={Col} target={vm} property="originalEmail">
                <FormLabel>{vm.translate("originalEmail")}</FormLabel>
                <Input disabled={true} />
              </FormGroup>
              <FormGroup as={Col} target={vm.item} property="newEmail">
                <FormLabel>{vm.translateAttribute("newEmail")}</FormLabel>
                <Input />
              </FormGroup>
            </Form.Row>
            <Form.Row>
              <FormGroup as={Col} xs={6} target={vm.item} property="officialRecordId">
                <FormLabel>{vm.translateAttribute("officialRecordId")}</FormLabel>
                <AdvancedInput transformation={Transformation.UpperCased} />
              </FormGroup>
              {vm.isAllowedToSendConfirmation && (
                <FormGroup as={Col} target={vm} property="confirmation">
                  <FormLabel />
                  <Check className="mt-3" custom label={vm.translate("sendConfirmation")} />
                </FormGroup>
              )}
            </Form.Row>
            <ButtonToolbar className="justify-content-center">
              <Button variant="light" size="sm" onClick={vm.onClose}>
                {vm.translateGeneral("cancel")}
              </Button>
              <Button type="submit" size="sm" variant="primary">
                {vm.translateGeneral("confirm")}
              </Button>
            </ButtonToolbar>
          </Form>
        </LoaderOverlay>
      </Modal.Body>
    </Modal>
  );
});

registerView(ChangeEmailView, ChangeEmailViewModel);
